<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import NumberInput from '../../../../components/ui/form/NumberInput.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  endPoint: string,
  permissions?: Permission[],
  outlet?: any | null
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const title = 'Tables'

const tableTypes = ref([
    {id: 'Round', name: 'Round'},
    {id: 'Square', name: 'Square'},
    {id: 'Rectangle', name: 'Rectangle'},
    {id: 'Octagon', name: 'Octagon'}
])

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
    id: props.data?.id || "",
    outlets_id: props.data?.outlets_id || props.outlet?.id || "",
    outlet: props.data?.outlet || props.outlet?.name || "",
    table_number: props.data?.table_number || "",
    capacity: props.data?.capacity || 1,
    color: props.data?.color || "",
    type: props.data?.type || 10,
    active: props.data?.active || true,
    uid: props.data?.uid || "",
  });

setFieldRules("outlets_id", [required("Outlet is required")]);
setFieldRules("table_number", [required("Table Number is required")]);
setFieldRules("capacity", [required("Capacity is required")]);
setFieldRules("type", [required("Table Type is required")]);

const handleSubmit = async (close: boolean, newRecord: boolean) => {
    console.log(formData.value)
    console.log(props.outlet)
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update-table' : 'create-table'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})

</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :tabList="[]" :formData="formData" @save="handleSubmit" :ignore-permission="true"
    @close="$emit('close')" width="35rem">
    <template #form>
      <div class="grid md:grid-cols-2 gap-6">
        
        <TextInput
          v-model="fields.outlet.value"
          label="Outlet"
          :readonly="true"
          :error="fields.outlets_id.touched ? fields.outlets_id.error : null"
          @blur="fields.outlets_id.touched = true"
        />

        <TextInput
          v-model="fields.table_number.value"
          label="Table Number"
          :readonly="isReadOnly"
          :error="fields.table_number.touched ? fields.table_number.error : null"
          @blur="fields.table_number.touched = true"
        />
        
        <NumberInput
          v-model="fields.capacity.value"
          label="Capacity"
          :readonly="isReadOnly"
          :error="fields.capacity.touched ? fields.capacity.error : null"
          @blur="fields.capacity.touched = true"
        />
        
        
        <SearchSelect
          v-model="fields.type.value"
          label="Type"
          :options="tableTypes"
          :remote="false"
          :readonly="isReadOnly"
          :error="
            fields.type.touched ? fields.type.error : null
          "
          @blur="fields.type.touched = true"
        />
        
         
        <!--<ColorInput
          v-model="fields.color.value"
          label="Color"
          :readonly="isReadOnly"
          :error="fields.color.touched ? fields.color.error : null"
          @blur="fields.color.touched = true"
        />-->
        
        
        <CheckInput
          v-model="fields.active.value"
          :readonly="isReadOnly"
          label="Active"
          :error="fields.active.touched ? fields.active.error : null"
          @blur="fields.active.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>